<template>
	<div class="submit-wrapper">
		<div class="logo">
			<img src="../assets/img/logo.png" alt="">
		</div>
		<div class="form-container">
			<form novalidate class="form-content">
				<md-field :class="nameClasses">
					<label>Name</label>
					<md-input v-model="form.name"></md-input>
					<span class="md-error">Name is required</span>
				</md-field>
				<md-field :class="emailClasses">
					<label>E-mail</label>
					<md-input v-model="form.email"></md-input>
					<span class="md-error">E-mail is required</span>
				</md-field>
				<md-field :class="registeredCompanyNameClasses">
					<label>Registered Company Name</label>
					<md-input v-model="form.registeredCompanyName"></md-input>
					<span class="md-error">Company Name is required</span>
				</md-field>
				<md-field :class="businessAddressClasses">
					<label>Business Address</label>
					<md-input v-model="form.businessAddress"></md-input>
					<span class="md-error">Business Address is required</span>
				</md-field>
				<md-field :class="mobilePhoneNumberClasses">
					<label>Mobile Phone Number</label>
					<md-input v-model="form.mobilePhoneNumber"></md-input>
					<span class="md-error">Mobile Phone Number is required</span>
				</md-field>
				<md-field :class="gameNameClasses">
					<label>Game Name</label>
					<md-input v-model="form.gameName"></md-input>
					<span class="md-error">Game Name is required</span>
				</md-field>
				<md-field :class="gameplayVideoLinkClasses">
					<label>Gameplay Video Link</label>
					<md-input v-model="form.gameplayVideoLink"></md-input>
					<span class="md-error">Gameplay Video Link is required</span>
				</md-field>
				<md-field :class="cityClasses">
					<label>City</label>
					<md-input v-model="form.city"></md-input>
					<span class="md-error">City is required</span>
				</md-field>
				<label class="submit-label">Do you work with Unity?</label>
				<md-radio v-model="form.useUnity" :value="true">Yes</md-radio>
				<md-radio v-model="form.useUnity" :value="false">No</md-radio>
				<div>
					<button class="submit-button" type="button" @click="sumitHandler" :disabled="loading">Submit</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Submit',

		data: () => ({
			form: {
				name: '',
				email: '',
				registeredCompanyName: '',
				businessAddress: '',
				mobilePhoneNumber: '',
				gameName: '',
				gameplayVideoLink: '',
				city: '',
				useUnity: true,
			},
			validate: false,
			loading: false,
		}),

		computed: {
			nameClasses() {
				return {
					'md-invalid': this.validate && !!!this.form.name
				}
			},
			emailClasses() {
				return {
					'md-invalid': this.validate && !!!this.form.email
				}
			},
			registeredCompanyNameClasses() {
				return {
					'md-invalid': this.validate && !!!this.form.registeredCompanyName
				}
			},
			businessAddressClasses() {
				return {
					'md-invalid': this.validate && !!!this.form.businessAddress
				}
			},
			mobilePhoneNumberClasses() {
				return {
					'md-invalid': this.validate && !!!this.form.mobilePhoneNumber
				}
			},
			gameNameClasses() {
				return {
					'md-invalid': this.validate && !!!this.form.gameName
				}
			},
			gameplayVideoLinkClasses() {
				return {
					'md-invalid': this.validate && !!!this.form.gameplayVideoLink
				}
			},
			cityClasses() {
				return {
					'md-invalid': this.validate && !!!this.form.city
				}
			},
		},

		methods: {
			sumitHandler() {
                let gaEventCategory = 'submit button click success';
				this.validate = true;
				if( this.validateHandler() ){
				    gaEventCategory = 'submit button click fail';
					const data = this.form;
					this.loading = true;
					this.$http.post('/api/submit', data).then((response) => {
						this.$router.push({
							name: 'submited'
						});
						this.loading = false;
					})
				}
                this.$ga.event({
                    eventCategory: gaEventCategory,
                    eventAction: 'click',
                    eventLabel: 'submit button click',
                });
			},
			validateHandler() {
				const { name, email, registeredCompanyName, businessAddress } = this.form;
				return !!name && !!email && !!registeredCompanyName && !!businessAddress;
			}
		}
	}
</script>

<style lang="less" scoped>
	.mobile {
		.submit-wrapper {
			.form-container {
				padding: 5%;

				.form-content {
					padding: 20px;
				}
			}
		}
	}
	.submit-wrapper {
		background-color: #000000;
		min-height: 100%;
		overflow: hidden;

		.logo {
			width: 220px;
			height: 66px;
			margin: 5% auto 0;
			img {
				display: block;
				height: 100%;
			}
		}

		.form-container {
			display: flex;
			justify-content: center;
			padding: 5% 10%;

			.form-content {
				padding: 50px 75px;
				background-color: #fff;
			    border-radius: 10px;
			    max-width: 882px;
			    position: relative;
			    width: 100%;
			}

			.submit-label {
				font-family: "Lato", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
				color: rgba(0, 0, 0, 0.54);
				font-size: 16px;
				display: block;
				padding-top: 10px;
			}
			.submit-button {
				background-color: #4A90E2;
			    border-radius: 3px;
			    display: block;
			    color: #fff;
			    margin: 40px auto 20px;
			    outline: none;
			    padding: 13px 30px;
			    transition: background-color 0.4s;
			    font-family: "Lato", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
		        font-size: 14px;
		        font-weight: 700;
		        line-height: normal;
				border: 0;
				cursor: pointer;
			}

			.submit-button:hover {
				border: 0;
				box-shadow: none;
				background-color: #63a3f7;
			}

			.submit-button:active {
				border: 0;
				box-shadow: none;
				background-color: #4b7ec1;
			}
		}
	}
</style>
